import React, { Component } from 'react';
import './DeepARGraph.css';
import { d3 } from 'react-d3-components';

import DeepARLegend from './DeepARLegend';

class DeepARGraph extends Component {
  componentDidMount() {
    this.buildGraph();
  }

  componentWillReceiveProps(props) {
    this.updateGraph(props.data, props);
  }

  buildGraph() {
    const {
      data,
      width = this.graph.offsetWidth,
      height = 400,
      propertyText,
      predictedPercentage,
      yAxisTitle,
    } = this.props;

    const margin = {
      bottom: 80,
      left: 60,
      right: 80,
      top: 40,
    };

    const chartWidth = width - margin.left - margin.right;
    const chartHeight = height - margin.top - margin.bottom;
    const x = d3.time.scale()
      .range([30, chartWidth])
      .domain([
        d3.min(data, d => d.x),
        d3.max(data, d => d.x)]);
    const y = d3.scale.linear()
      .range([chartHeight, 0])
      .domain([
        d3.min(data, d => Math.min(d.y, d.lowerlayer, d.upperlayer)),
        d3.max(data, d => Math.max(d.y, d.lowerlayer, d.upperlayer)),
      ]);

    const xAxis = d3.svg.axis().scale(x).orient('bottom')
      .innerTickSize(-chartHeight)
      .outerTickSize(0)
      .tickPadding(10)
      .tickFormat(d3.time.format('%b %d, %Y %H:%M'));

    const yAxis = d3.svg.axis().scale(y).orient('left')
      .innerTickSize(-chartWidth)
      .outerTickSize(0)
      .tickPadding(10);

    const svg = d3.select(this.graph).append('svg')
      .attr('width', width)
      .attr('height', height)
      .append('g')
      .attr('transform', `translate(${margin.left}, ${margin.top})`);


    this.setState({
      svg,
    }, () => {
      this.addAxes(xAxis, yAxis, margin, chartWidth, chartHeight, propertyText, yAxisTitle);
      this.drawPaths(x, y, data, chartHeight, chartWidth, predictedPercentage);
    });
  }

  addAxes(xAxis, yAxis, margin, chartWidth, chartHeight, propertyText) {
    const { svg } = this.state;

    const axes = svg.append('g')
      .attr('class', 'axies');

    axes.append('g')
      .attr('class', 'x axis')
      .attr('transform', `translate(0,${chartHeight})`)
      .call(xAxis)
      .selectAll('text')
      .attr('y', 10)
      .attr('x', 9)
      .attr('dy', '.35em')
      .attr('transform', 'rotate(25)')
      .style('text-anchor', 'start');

    axes.append('g')
      .attr('class', 'y axis')
      .attr('transform', 'translate(30,0)')
      .call(yAxis)
      .append('text')
      .attr('transform', 'rotate(-90)')
      .attr('y', -55)
      .attr('dy', '.71em')
      .style('text-anchor', 'end')
      .text(`${propertyText}`);
  }

  drawPaths(x, y, data, height, width, predictedPercentage) {
    const { svg } = this.state;

    const midPoints = data.map(d => {
      const dataPoints = [d.y, d.upperlayer, d.lowerlayer].sort();
      return dataPoints[1];
    });

    const line1 = d3.svg.line()
      .x(d => x(d.x))
      .y((d, i) => y(midPoints[i]));

    const area = d3.svg.area()
      .x(d => x(d.x))
      .y0(d => y(Math.max(d.upperlayer, d.lowerlayer, d.y)))
      .y1(d => y(Math.min(d.lowerlayer, d.upperlayer, d.y)));

    const graph = svg.append('g')
      .attr('class', 'graph');

    graph.datum(data);

    graph.append('path')
      .attr('class', 'area')
      .attr('d', area);

    graph.append('path')
      .attr('class', 'line predicted')
      .attr('d', line1);

    graph.append('line')
      .attr('x1', (predictedPercentage * width))
      .attr('x2', (predictedPercentage * width))
      .attr('y1', 0)
      .attr('y2', height)
      .attr('stroke-width', 2)
      .style('stroke-dasharray', ('3, 3'))
      .attr('stroke', 'black');
  }

  updateGraph(data, props) {
    const {
      width = this.graph.offsetWidth,
      height = 400,
    } = props;

    const margin = {
      bottom: 80,
      left: 60,
      right: 80,
      top: 40,
    };

    const chartWidth = width - margin.left - margin.right;
    const chartHeight = height - margin.top - margin.bottom;

    const x = d3.time.scale()
      .range([30, chartWidth])
      .domain([
        d3.min(data, d => d.x),
        d3.max(data, d => d.x)]);

    const y = d3.scale.linear()
      .range([chartHeight, 0])
      .domain([
        d3.min(data, d => Math.min(d.y, d.lowerlayer, d.upperlayer)),
        d3.max(data, d => Math.max(d.y, d.lowerlayer, d.upperlayer)),
      ]);

    const xAxis = d3.svg.axis().scale(x).orient('bottom')
      .innerTickSize(-chartHeight)
      .outerTickSize(0)
      .tickPadding(10)
      .tickFormat(d3.time.format('%b %d, %Y %H:%M'));

    const yAxis = d3.svg.axis().scale(y).orient('left')
      .innerTickSize(-chartWidth)
      .outerTickSize(0)
      .tickPadding(10);

    this.updatePaths(x, y, data);
    this.updateAxes(xAxis, yAxis, margin, chartWidth, chartHeight);
  }

  updatePaths(x, y, data) {
    const { svg } = this.state;

    const midPoints = data.map(d => {
      const dataPoints = [d.y, d.upperlayer, d.lowerlayer].sort();
      return dataPoints[1];
    });

    const line1 = d3.svg.line()
      .x(d => x(d.x))
      .y((d, i) => y(midPoints[i]));

    const area = d3.svg.area()
      .x(d => x(d.x))
      .y0(d => y(Math.max(d.upperlayer, d.lowerlayer, d.y)))
      .y1(d => y(Math.min(d.lowerlayer, d.upperlayer, d.y)));

    const graph = svg.select('g.graph')
      .attr('class', 'graph');

    graph.datum(data);

    graph.select('.area')
      .attr('d', area);

    graph.select('.predicted')
      .attr('d', line1);
  }

  updateAxes(xAxis, yAxis) {
    const { svg } = this.state;

    const axes = svg.select('.axies');

    axes.select('.x.axis')
      .call(xAxis)
      .selectAll('text')
      .attr('y', 10)
      .attr('x', 9)
      .attr('dy', '.35em')
      .attr('transform', 'rotate(25)')
      .style('text-anchor', 'start');

    axes.select('.y.axis')
      .call(yAxis);
  }

  render() {
    return (
      <div className="deepAR graph-row">
        <div className="graph-row-right">
          <DeepARLegend />
        </div>
        <div className="deepARSpace graph-row-content">
          <div ref={(c) => { this.graph = c; }} />
        </div>
      </div>
    );
  }
}

export default DeepARGraph;
